module.exports = {
	"Evaluation": null,
	"Email": "lspears@polyrents.com",
	"TimeOfRequest": "2018-02-19T21:43:18.1322334-06:00",
	"SecurityToken": "ZTvcnViU9ssLRhr/DhA3QHbiHx9Evi3PAgRtp5W5NgPlJSd0i5VhYB6+R/o8rT3W",
	"Id": "2e3e7a13-59cd-4798-93c7-f5a3839becf5",
	"Questions": [
		{
			"Text": "In what county do you live?",
			"Id": "008d94fa-74cb-44d3-a038-e274ca4017d4",
			"Answers": [
				{
					"Text": "Menard",
					"Id": "7eb47fc1-afb6-4abd-ad27-43e624c671cb"
				},
				{
					"Text": "Cook",
					"Id": "7829b4a5-701b-4f16-bd71-1c6f7a2476f1"
				},
				{
					"Text": "Calhoun",
					"Id": "b4b90024-3239-4f0b-bb9f-f4435e3b4d15"
				},
				{
					"Text": "White",
					"Id": "e7d2946f-d0c7-4fdf-bde4-835917eed677"
				},
				{
					"Text": "None of the above",
					"Id": "c12210d1-2d34-434e-89ee-80c7b89cdc9b"
				}
			],
			"SelectedAnswerId": null
		},
		{
			"Text": "Which zip code has ever been a part of your address?",
			"Id": "d87ecd5e-0845-424f-8bf0-60dd8624d140",
			"Answers": [
				{
					"Text": "60524",
					"Id": "73e25bc8-089e-4d16-9cb7-83c96b7b037e"
				},
				{
					"Text": "60620",
					"Id": "8b29a818-7a71-4cd2-9343-618a85db7770"
				},
				{
					"Text": "60940",
					"Id": "ee8b1292-ef60-4269-a707-31d89515761a"
				},
				{
					"Text": "60724",
					"Id": "df82630b-0ccc-4e1a-8374-36f41f32f14c"
				},
				{
					"Text": "None of the above",
					"Id": "ac25adc3-c4f5-4528-902a-b12b9500ee8e"
				}
			],
			"SelectedAnswerId": null
		},
		{
			"Text": "What was the original amount of your most recent mortgage?",
			"Id": "0b1c3312-8d6d-49df-afbb-1a33bcf08a2a",
			"Answers": [
				{
					"Text": "$179,200",
					"Id": "b31965c8-51d9-4a28-977b-2421a46f3f93"
				},
				{
					"Text": "$128,000",
					"Id": "bab0ad3d-3437-4782-9d28-59de8544d49e"
				},
				{
					"Text": "$102,400",
					"Id": "7d653dd3-9b1e-4c03-b516-dff634aae661"
				},
				{
					"Text": "$76,800",
					"Id": "8a6abfbb-5ddb-4ee0-a3be-545fb8d14821"
				},
				{
					"Text": "None of the above",
					"Id": "25151681-89a8-4410-a54e-bf075ea24b2e"
				}
			],
			"SelectedAnswerId": null
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/util/test_data/tu_exam.json
// module id = 603
// module chunks = 0